module.exports = __webpack_public_path__ + "img/05.2064d540.jpg";